import { useModulesStore } from '@/stores/modules'
import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { IModule } from '../../../@types'
import services from '../../../services'

export function useData() {
  const {
    data: modules,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['/modules'],
    queryFn: services.modules.getAll,
  })

  const { level } = useModulesStore()
  const { setSelectedItem } = useModulesStore()
  const [filteredByLevel, setFilteredByLevel] = useState<IModule[] | null>(null)

  const onItemClick = (id: string) => {
    setSelectedItem(getModuleById(id))
  }

  const getModuleById = (id: string) => {
    const module: IModule | null =
      modules?.find((item) => item.id === id) ?? null
    return module
  }

  useEffect(() => {
    if (modules) {
      if (!level) {
        setFilteredByLevel(null) // Se não houver filtro, não filtramos
      } else {
        const filtered = modules.filter(
          (item) => String(item.level) === String(level),
        )
        setFilteredByLevel(filtered) // Filtramos os módulos pelo nível
      }
    }
  }, [modules, level])

  return {
    isLoading,
    error,
    modules,
    refetch,
    getModuleById,
    onItemClick,
    filteredByLevel,
  }
}
